import {
  AddPromotionBtn,
  Container,
  Header,
  ListContainer,
  SearchBar,
  SearchContainer,
  SearchIcon,
  SortContainer,
  Title
} from './style';
import { DropDown } from '../../../component/dropDown';
import { PromotionListCard } from '../components/promotionListCard';
import { ChangeEvent, useMemo, useState } from 'react';
import { AddPromotion } from '../components/promotionModal/addPromotions';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeletePromotionsMutation,
  useGetAllPromotionsQuery
} from '../../../store/promotion/api';
import useDebounce from '../../../utils/useDebounce';
import searchIcon from '../../../assets/Search.svg';
import { generateUrl } from '../../../utils/urlGenerator';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { Loader } from '../../../component/loader';
import { Paginate } from '../../../component/pagenate';

export const AllPromotions = () => {
  const [sortBy, setSortBy] = useState('');
  const [addPromotionModal, setAddPromotionModal] = useState(false);
  const [promotionId, setPromotionId] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [deletePromotionModal, setDeletePromotionModal] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const debounceSearchPromotions = useDebounce(searchValue, 500);

  const [deletePromotionContent, { isLoading: isDeleteLoading }] =
    useDeletePromotionsMutation();
  const handleAddPromotion = () => {
    setAddPromotionModal(true);
  };
  const promotionDetails = useMemo(
    () =>
      generateUrl({
        pageSize: '6',
        pageNo: pageNumber.toString(),
        search: debounceSearchPromotions
      }),
    [pageNumber, debounceSearchPromotions]
  );
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const { data: promotionsList, isLoading: isPromotionsListLoading } =
    useGetAllPromotionsQuery(promotionDetails);
  const handleDeletePromotion = (item: string) => {
    setDeletePromotionModal(true);
    setPromotionId(item);
  };
  const handlePromotionDelete = () => {
    deletePromotionContent(promotionId)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeletePromotionModal(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };

  return (
    <Container>
      {isPromotionsListLoading && <Loader />}
      {addPromotionModal && <AddPromotion setShow={setAddPromotionModal} />}
      {deletePromotionModal && (
        <DeleteModal
          deleteTitle="Delete Promotion"
          isLoading={isDeleteLoading}
          deleteText="Are you sure you want to delete? this action can’t be undone?"
          cancelBtnClick={() => setDeletePromotionModal(false)}
          deleteBtnClick={handlePromotionDelete}
        />
      )}
      <Header>
        <Title>All Promotion</Title>
        <AddPromotionBtn onClick={() => handleAddPromotion()}>
          Add Promotion
        </AddPromotionBtn>
      </Header>
      <SortContainer>
        <SearchContainer>
          <SearchIcon src={searchIcon} alt="" />
          <SearchBar
            type={'text'}
            placeholder=" Search for Item"
            onChange={handleSearchChange}
            value={searchValue}
          />
        </SearchContainer>
        <DropDown
          value={sortBy}
          placeholder="All Categories"
          onSelect={(item) => {
            setSortBy(item === 'All Categories' ? '' : item);
          }}
          options={['Real estate', 'Lifestyle', 'Hotels', 'Shopping']}
        />
      </SortContainer>
      {promotionsList?.data.fetchedData.length && !isPromotionsListLoading ? (
        <ListContainer>
          {promotionsList?.data.fetchedData.map((item, index) => (
            <PromotionListCard
              handleDelete={() => handleDeletePromotion(item._id)}
              key={item._id}
              promotionItem={item}
            />
          ))}
        </ListContainer>
      ) : (
        <EmptyState>
          <EmptyTxt>
            No Promotions yet, click on the button below to add Promotions
          </EmptyTxt>
          <AddPromotionBtn onClick={() => handleAddPromotion()}>
            Add Promotions
          </AddPromotionBtn>
        </EmptyState>
      )}
      {!!promotionsList?.data.fetchedData.length && (
        <Paginate
          pageNo={promotionsList.data.pageNo}
          noOfPages={promotionsList.data.noOfPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
      )}
    </Container>
  );
};
